module.exports = __webpack_public_path__ + "static/media/Favorites_Icon_Active@3x.63ff14fd.png";